import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";

export default function CTASection() {
  const { tr } = useLang();
  const h = tr("home");

  return (
    <section data-testid="closing-section" className="relative overflow-hidden bg-navy noise py-24 lg:py-36">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/10 blur-[130px]" />
      <div className="relative mx-auto max-w-4xl px-6 text-center lg:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">{h.closingNote}</p>
        </Reveal>
        <Reveal delay={0.12}>
          <h2 className="mt-8 font-serif text-3xl leading-snug tracking-tight text-ivory sm:text-4xl lg:text-6xl">
            {h.closingTitle?.[0]}
            <br />
            <em className="text-gold-bright">{h.closingTitle?.[1]}</em>
          </h2>
        </Reveal>
        <Reveal delay={0.24}>
          <Link
            to="/contact"
            data-testid="closing-cta"
            className="group mt-12 inline-flex items-center gap-3 bg-gold px-10 py-5 text-xs font-semibold uppercase tracking-[0.2em] text-navy transition-colors hover:bg-gold-bright"
          >
            {h.closingCta}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
